import React from 'react';
import Skeleton from '../../Skeleton/Skeleton';
import './chat-messages-list.scss';

interface SkeletonBubble {
  align: 'left' | 'right';
  width: string;
  height: number;
}

const SKELETON_BUBBLES: SkeletonBubble[] = [
  { align: 'left', width: '42%', height: 44 },
  { align: 'right', width: '34%', height: 40 },
  { align: 'left', width: '52%', height: 58 },
  { align: 'left', width: '28%', height: 40 },
  { align: 'right', width: '44%', height: 44 },
  { align: 'right', width: '24%', height: 40 },
  { align: 'left', width: '38%', height: 44 },
];

const ChatMessagesSkeleton = () => (
  <div className="chat-messages-skeleton" aria-busy="true">
    {SKELETON_BUBBLES.map((bubble: SkeletonBubble, index: number) => (
      <div
        key={index}
        className={`skeleton-message-row ${
          bubble.align === 'right' ? 'align-right' : ''
        }`}
      >
        {bubble.align === 'left' && (
          <Skeleton variant="circle" width={44} height={44} />
        )}
        <Skeleton
          variant="rect"
          width={bubble.width}
          height={bubble.height}
          className="skeleton-bubble"
        />
      </div>
    ))}
  </div>
);

export default ChatMessagesSkeleton;
